import { http } from '@pendo/http';

export function fetchFeatureFlags () {
    return http.get('/api/s/_SID_/segmentflag').then((res) => res.data);
}

export function toggleFeatureFlag (flagName, enabled) {
    return http.put(`/api/s/_SID_/segmentflag/${flagName}/enabled`, { enabled }).then((res) => res.data);
}

export function createFeatureFlag (featureFlag) {
    return http.post('/api/s/_SID_/segmentflag', featureFlag).then((res) => res.data);
}
